import { createActionTypes } from 'utils/action/actionTypes';

export const ADD_TENANT = createActionTypes('ADD_TENANT');
export const FETCH_TENANT = createActionTypes('FETCH_TENANT');
export const GET_TENANT = createActionTypes('GET_TENANT');
export const DELETE_TENANT = createActionTypes('DELETE_TENANT');
export const UPDATE_TENANT = createActionTypes('UPDATE_TENANT');
export const UPDATE_TENANT_CONTACT_INFORMATION = createActionTypes('UPDATE_TENANT_CONTACT_INFORMATION');
